// extracted by mini-css-extract-plugin
module.exports = {"OfferDurationContainer":"OfferDurationView_OfferDurationContainer__12WBs","HelperText":"OfferDurationView_HelperText__2nSD9"};